import LDClient from 'launchdarkly-js-client-sdk';
import globalConfig from 'react-global-configuration';

/**
 * Fetches the status of a LaunchDarkly flag for a specific organization.
 * @param {string} isAnonymous - Will fetch flag status anonymous without need of key.
 * @param {string} flagName - The name of the feature flag to get status.
 * @param {string} orgAlias - The alias of the organisation to check if flag enable/disabled.
 * @param {string} userEmail - The email of the user to check if flag enable/disabled.
 * @return {Promise<boolean>} - A promise that resolves to the status of the feature flag.
 */
const getFlagStatus = async ({
  isAnonymous = false,
  flagName,
  userEmail = null,
  orgAlias = null





}) => {
  const defaultClientSideID = '6260be9f41b3481588213f7e';
  let clientSideID = defaultClientSideID;
  try {
    clientSideID = globalConfig.get('featureFlagServiceClientId');
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log('Error in reading featureFlagServiceClientId');
  }

  const key = userEmail || 'unknown-user-id';

  const context = {
    kind: 'user',
    ...(!isAnonymous ? { key } : { anonymous: true }),
    ...(orgAlias ? { orgAlias } : null)
  };

  const ldClient = await LDClient.initialize(clientSideID, context);

  return new Promise((resolve, reject) => {
    ldClient.on('ready', () => {
      const flagValue = ldClient.variation(flagName, false);
      resolve(flagValue);
    });

    ldClient.on('error', (err) => {
      reject(err);
    });
  });
};

export default getFlagStatus;